import { useContext } from 'react'
import { ConsentContext } from '@/context/ConsentContext'

export const useConsent = () => {
  const { consentReady } = useContext(ConsentContext)
  return { consentReady }
}
